/* import __COLOCATED_TEMPLATE__ from './salesforce-hovercard.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();